/**
 * getPlayedAnswer.js
 * Written by: Alex Kasemir
 */

import { getStorage } from '@minerva-analytics/pantheon';


export const GET_PLAYED_ANSWER_START = `GET_PLAYED_ANSWER_START`;
export const GET_PLAYED_ANSWER_SUCCESS = `GET_PLAYED_ANSWER_SUCCESS`;
export const GET_PLAYED_ANSWER_FAILURE = `GET_PLAYED_ANSWER_FAILURE`;

export const getPlayedAnswerStart = () => ({
  type: GET_PLAYED_ANSWER_START,
});

export const getPlayedAnswerSuccess = (id, playedAnswer) => ({ // eslint-disable-line
  type: GET_PLAYED_ANSWER_SUCCESS,
  id,
  playedAnswer,
});

export const getPlayedAnswerFailure = (id, error) => ({
  type: GET_PLAYED_ANSWER_FAILURE,
  id,
  error,
});

/**
 * Description of the getPlayedAnswer action
 */
export const getPlayedAnswer = (id, cookies) => {
  return (dispatch) => {
    dispatch(getPlayedAnswerStart());
    let retrieved = `{}`;
    if (__CLIENT__) {
      retrieved = getStorage({
        key: `playedAnswer`,
      });
    } else {
      retrieved = cookies ? cookies.playedAnswer : null;
    }
    const previousPlayed = typeof retrieved === `object`
      ? retrieved
      : JSON.parse(retrieved || `{}`);
    if (previousPlayed.question === parseInt(id, 10)) {
      dispatch(getPlayedAnswerSuccess(id, previousPlayed));
    } else {
      dispatch(getPlayedAnswerFailure(id));
    }
  };
};

export default getPlayedAnswer;
